<form
    [formGroup]="timesheetForm"
    [class]="timesheetForm.controls.locked.value || readOnly ? 'tw-cursor' : ''"
>
    <div
        class="tw-text-center tw-grid tw-grid-cols-8 lg:tw-grid-cols-10 tw-gap-2"
    >
        <div
            [matTooltip]="tooltipText()"
            matTooltipPosition="after"
            class="tw-flex lg:tw-flex-col tw-gap-2 lg:tw-gap-0 tw-flex-row tw-text-left tw-min-w-0 lg:tw-justify-center lg:tw-max-w-96 tw-w-full tw-col-span-8 lg:tw-col-span-2"
        >
            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.clientName.value }}</span>
            </div>
            <mat-divider class="tw-hidden lg:tw-block"></mat-divider>
            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.projectName.value }}</span>
            </div>
            <mat-divider class="tw-hidden lg:tw-block"></mat-divider>
            <div
                class="tw-whitespace-nowrap tw-flex-initial tw-text-ellipsis tw-overflow-hidden"
            >
                <span>{{ timesheetForm.controls.taskName.value }}</span>
            </div>
        </div>

        @for (day of daysOfWeek; track day) {
            <mat-form-field
                class="tw-text-xs tw-flex-1 tw-pt-5"
                appearance="outline"
                [class]="
                    timesheetForm.controls.locked.value || readOnly
                        ? 'tw-pointer-events-none tw-opacity-50'
                        : ''
                "
                floatLabel="always"
            >
                <mat-label>
                    {{ day.abbreviation | titlecase }} {{ getDay($index) }}
                </mat-label>

                <input
                    type="number"
                    matInput
                    #hours
                    (click)="hours.select()"
                    [formControlName]="day.name"
                    onkeydown="return event.key !== 'e' && event.key !== '-' && event.key !== '+'"
                    min="0"
                />

                <mat-icon
                    (click)="editNoteForDay(day.name)"
                    [matTooltip]="
                        timesheetForm.controls.locked.value || readOnly
                            ? 'View Notes for Day'
                            : 'Edit Notes for Day'
                    "
                    class="hover:tw-cursor-pointer !tw-p-0"
                    [ngClass]="{
                        'tw-text-green-500': hasNotes(day.name, timesheetForm)
                    }"
                    matSuffix
                >
                    note_add
                </mat-icon>
                <mat-error
                    *ngIf="
                        timesheetForm.controls[day.name].errors?.invalidDecimal
                    "
                >
                    {{ errorText.invalidDecimal }}
                </mat-error>

                <mat-error *ngIf="timesheetForm.controls[day.name].errors?.min">
                    {{ errorText.minimumValue }}
                </mat-error>

                <mat-error *ngIf="timesheetForm.controls[day.name].errors?.max">
                    {{ errorText.maximumValue }}
                </mat-error>

                <mat-error
                    *ngIf="
                        timesheetForm.controls[day.name].errors?.notesRequired
                    "
                >
                    {{ errorText.notesRequired }}
                </mat-error>
            </mat-form-field>
        }
        <div class="tw-flex">
            <div class="tw-self-center tw-justify-self-center">
                Task Total
                <mat-divider></mat-divider>
                {{ totalHours }}
            </div>
            <div
                *ngIf="!(timesheetForm.controls.locked.value || readOnly)"
                class="tw-items-center tw-flex tw-justify-center"
            >
                <button
                    mat-icon-button
                    *ngIf="!(timesheetForm.controls.locked.value || readOnly)"
                    (click)="clickRemoveEvent.emit(this.timesheetForm)"
                    matTooltip="Remove Timesheet"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
    </div>
</form>
